// extracted by mini-css-extract-plugin
export default {"tx":"_3ec4d084ff","line":"_5b6fdaf539"};